// extracted by mini-css-extract-plugin
export var Section = "Section-module--Section--15e1d";
export var SectionInner = "Section-module--Section-inner--2c301";